import s from './NotFound.module.scss';
import {useNavigate} from "react-router-dom";

const NotFound = ({loading}) => {
    const navigate = useNavigate();
    return (
        <div className={s.emptyState}>
            <div className={s.emptyIcon}>🔍</div>

            <h3>ツアーが見つかりませんでした</h3>

            <p>
                条件に一致するツアーがありません。<br/>
                フィルターを変更するか、すべてのツアーをご覧ください。
            </p>

            <div className={s.emptyActions}>
                {/*<button*/}
                {/*    className={s.clearBtn}*/}
                {/*    onClick={clearAllFilters}*/}
                {/*>*/}
                {/*    フィルターをクリア*/}
                {/*</button>*/}

                <button
                    className={s.browseBtn}
                    onClick={() => navigate("/all-tours")}
                >
                    すべてのツアーを見る
                </button>
            </div>
        </div>
    );
};

export default NotFound;
